export default[
    {
        name:"Allnew",
        path:"/Dynamic/Allnew",
        component:() => import("@/view/Dynamic/allnew"),
        meta:{
            title:"全部",
        }
    },
    {
        name:"Industry",
        path:"/Dynamic/Industry",
        component:() => import("@/view/Dynamic/industry"),
        meta:{
            title:"行业动态",
        }
    },
    {
        name:"Renew",
        path:"/Dynamic/Renew",
        component:() => import("@/view/Dynamic/renew"),
        meta:{
            title:"软件更新",
        }
    },
    {
        name:"dynamicDetail",
        path:"/Dynamic/:url/dynamicDetail",
        component:() => import("@/view/Dynamic/dynamicDetail"),
        meta:{
            title:"文章详情",
        }
    }
]